import { createStore } from 'vuex';
import axios from 'axios';
import informator from './modules/websockets/informator';

export default createStore({
  modules: {
    informator
  },
  state: {
    isLogged: false,
    globalKey: 1,
    globalKeyKeyt: 1,
    resize: {
      w: false,
      h: false,
    },
    isMobile: false,
    loader: false,
    active_loadings: [],
    error: false,
    fingerprint: false,
    pay_pass: false,
    paypass_success_callback: false,
    config: false,
    modal: {
      action: false,
      type: false,
      content: false,
    },
    darkWrapper: false,
    title: '',
    titleHint: false,
    userData: false,
    menu: false,
    webView: false,
    webViewStatusBar: 0,
    individual: process.env.VUE_APP_INDIVIDUAL ? process.env.VUE_APP_INDIVIDUAL : false,
    logoMobile: {
      img: 'mobile_logo_default.svg', 
      style: '',
    },
    logoTablet: {
      img: 'tablet_logo_default.svg',
      style: '',
    },
    domains: false,
    active_swap: false,
    warning_info: {
      warning_visible: false,
      warning_text: ''
    },
    atmIncassRest: '',
    rateItem: false,
    notifications: {
      list: [],
      on_page: 4
    },
    routerKey: 1,
    safety: false,
    result: false,
    notification: {
      type: false,
      text: false
    },
    sidePanel: {
      visible: false,
      title: '',
      content: null
    },
    notificationPanel: {
      visible: false
    }
  },
  mutations: {
    SET_RESULT: (state, n) => {
      state.result = n;
    },
    DELETE_RESULT: (state) => {
      // console.log('DELETE_RESULT');
      state.result = false;
    },
    IS_LOGGED: (state, n) => {
      if (state.isLogged === n) {
        return
      }
      state.isLogged = n;
      // if (!state.webView) {
      //   return
      // }
      // console.log('ISLOGGED_HOOK', window)
      try {
        if (!n) {
          if (window.Android) {
            window.Android.logout();
          } else if (window.webkit) {
            window.webkit.messageHandlers.logout.postMessage("");
          }
        } else if (n) {
          if (window.Android) {
            window.Android.auth();
          } else if (window.webkit) {
            window.webkit.messageHandlers.auth.postMessage("");
          }
        }
      } catch (err) {
        // alert(err)
        console.log(err)
      }
    },
    RENAME_KEYT: (state, data) => {
      let k = false;
      state.userData.keyts.forEach(e => {
          if (e.keyt == data.keyt) {
              if (data.v) {
                  e.hide = e.hide == '1' ? '0' : '1';
              }
              if (data.name) {
                  e.name = data.name;
              }
              k = e;
          }
      });
      let d = {
          keyt : k.keyt,
          name : k.name,
          hide : k.hide
      }
      axios.post('RenameKeyt', {data: d})
    },
    DELETE_KEYT: (state, data) => {
      axios.post('DeleteKeyt', { data: { keyt: data.keyt } })
    },
    GLOBAL_KEY: (state) => {
      state.globalKey = state.globalKey + 1;
    },
    GLOBAL_KEY_KEYT: (state) => {
      state.globalKeyKeyt = state.globalKeyKeyt + 1;
    },
    TITLE: (state, n) => {
      state.title = n;
    },
    TITLE_HINT: (state, n) => {
      state.titleHint = n;
    },
    SAFETY: (state, n) => {
      state.safety = n;
    },
    RESIZE: (state, n) => {
      state.resize = n;
    },
    IS_MOBILE: (state, n) => {
      state.isMobile = n;
    },
    FINGERPRINT: (state, n) => {
      state.fingerprint = n;
    },
    PAY_PASS: (state, n) => {
      state.pay_pass = n;
    },
    PAYPASS_SUCCESS_CALLBACK: (state, n) => {
      state.paypass_success_callback = n;
    },
    MODAL: (state, n) => {
      state.modal = n;
    },
    MODAL_ACTION: (state, n) => {
      state.modal.action = n;
    },
    MODAL_TYPE: (state, n) => {
      state.modal.type = n;
    },
    MODAL_CONTENT: (state, n) => {
      state.modal.content = n;
    },
    LOADER: (state, n) => {
      state.loader = n;
    },
    SET_ACTIVE_LOADING: (state, n) => {
      state.active_loadings[n] = 1;
    },
    DEL_ACTIVE_LOADING: (state, n) => {
      delete state.active_loadings[n];
    },
    MENU: (state, n) => {
      state.menu = n;
    },
    DARK_WRAPPER: (state, n) => {
      state.darkWrapper = n;
    },
    USER_DATA: (state, n) => {
      if (n.user_info) {
        if (n.user_info.avatar.value.length > 0) {
          n.avatar = n.user_info.avatar.value[0].body;  
        }
      }
      state.userData = n;
    },
    USER_DATA_INFO: (state, n) => {
      state.userData.user_info = n;
    },
    USER_DATA_AVATAR: (state, n) => {
      state.userData.avatar = n;
    },
    USER_DATA_TEMPLATES: (state, n) => {
      state.userData.templates = n;
    },
    USER_DATA_PASS: (state, n) => {
      state.userData.pass = n;
    },
    USER_DATA_INFORM: (state, n) => {
      state.userData.inform = n;
    },
    USER_DATA_KEYTS: (state, n) => {
      let arr = state.userData.keyts
      if (Array.isArray(arr)) {
        arr.forEach(e => {

          // "Отладка"
          // e.rate = '2';


          if (('rate' in e) && e.rate !== '') {
            n.forEach(ne => {
              if (e.keyt == ne.keyt) {
                ne.rate = e.rate;
              }
            })
          }
        });
      }
      state.userData.keyts = n;
    },
    DOMAINS: (state, n) => {
      state.domains = n;
    },
    PRE_CONFIG: (state, n) => {
      state.config = n;
    },
    SAVE_ATM_INCASS_REST_DATA: (state, n) => {
      state.atmIncassRest = JSON.parse(JSON.stringify(n));
    },
    LOGO_MOBILE: (state, n)  => {
      if (n.img != false) {
        state.logoMobile.img = n.img;
      }
      if (n.style != '') {
        state.logoMobile.style = n.style;
      }
    },
    LOGO_TABLET: (state, n)  => {
      if (n.img != false) {
        state.logoTablet.img = n.img;
      }
      if (n.style != '') {
        state.logoTablet.style = n.style;
      }
    },
    WEB_VIEW: (state, n) => {
      state.webView = n;
    },
    WEB_VIEW_STATUS_BAR: (state, n) => {
      state.webViewStatusBar = Number(n);
    },
    ACTIVE_SWAP: (state, n) => {
      state.active_swap = n;
    },
    SAVE_RATE: (state, n) => {
      state.rateItem = n;
    },
    WARNING: (state, n) => {
      state.notifications.list.push({ id: state.notifications.list.length, ...n })
    },
    REMOVE_WARNING: (state, n) => {
      state.notifications.list = state.notifications.list.filter(item => item.id !== n);
    },
    CHANGE_AMOUNT_WARNINGS: (state, n) => {
      state.notifications.on_page = n;
    },
    ROUTER_KEY: (state) => {
      state.routerKey = state.routerKey + 1;
    },
    CURR_LIST: (state, list) => {
      state.userData.currs = list;
    },
    NOTIFICATION: (state, n) => {
      state.notification = n
    },
    SIDE_PANEL_SHOW: (state, payload) => {
      console.log('SIDE_PANEL_SHOW', payload);
      state.sidePanel.visible = true;
      state.sidePanel.title = payload.title || '';
      state.sidePanel.content = payload.content || null;
    },
    SIDE_PANEL_HIDE: (state) => {
      state.sidePanel.visible = false;
      state.sidePanel.title = '';
      state.sidePanel.content = null;
    },
    SIDE_PANEL_SET_TITLE: (state, title) => {
      state.sidePanel.title = title;
    },
    NOTIFICATION_PANEL_SHOW: (state) => {
      state.notificationPanel.visible = true;
    },
    NOTIFICATION_PANEL_HIDE: (state) => {
      state.notificationPanel.visible = false;
    }
  },
  actions: {
    logout(context, router) {
      axios.post('logout').then(res => {console.log('logout');
        // context.commit('USER_DATA', false);
      });
    },
    reRender(context) {
      context.commit('GLOBAL_KEY');
      axios.post('reLang', {no_loader: true, data: {}}).then(res => {
        context.commit('LOGO_MOBILE', res.data.body.logoMobile);
        context.commit('LOGO_TABLET', res.data.body.logoTablet);
      })
    },
    modalAnswer(context, p) {
      context.commit('MODAL_ACTION', true);
      context.commit('MODAL_TYPE', 'answer');
      context.commit('MODAL_CONTENT', {result: p.code,
                                       result_text: p.text});
    },
    informer(context) {
      if (context.getters.get_isLogged) {
          axios.post('Informator', {no_loader: true, data: {del_from_server: '0'}}).then(res => {
            if (!context.getters.get_isLogged || res.data.error || !res.data.body) {
              return
            }
            let tmp = {
              'payments': [],
              'messages': [],
              'payrequests': [],
              'support': [],
              'news': [],
            };
            res.data.body.informator.forEach(e => {
              if ( e['subj'] == '3' ) {
                tmp.payments.push(e);
              } else if ( e['subj'] === '2' ) {
                tmp.messages.push(e)
              } else if ( e['subj'] === '1' ) {
                tmp.payrequests.push(e)
              } else if ( e['subj'] === '4' ) {
                tmp.support.push(e)
              } else if ( e['subj'] == '5' ) {
                tmp.news.push(e)
              }
            });
            context.commit('USER_DATA_INFORM', tmp);
            setTimeout(() => {
              context.dispatch('informer');
            }, 60000);
          })
      }
    },
    isLogged(context, p) {
      axios.post('isLogged').then(res => {
        if (res.data.body.user_data) {
          // console.log('isLOgged', res.data.body.user_data)
          context.commit('USER_DATA', res.data.body.user_data);
          if (res.data.body.lang && !localStorage.getItem("lang")) {
            p.i18n.locale = res.data.body.lang;
            localStorage.setItem("lang", res.data.body.lang);
          }
          if (res.data.body.user_data.config) {
            context.commit('PRE_CONFIG', res.data.body.user_data.config);
            if (res.data.body.user_data.config.PAGE_TITLE) {
              document.title = res.data.body.user_data.config.PAGE_TITLE;
            }
            if (res.data.body.user_data.config.FAVICON) {
              let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
              link.type = 'image/x-icon';
              link.rel = 'shortcut icon';
              link.href = res.data.body.user_data.config.FAVICON;
              document.getElementsByTagName('head')[0].appendChild(link);
            }
          }
          context.dispatch('informer');
        } 
        if (res.data.body.logoMobile) {
          context.commit('LOGO_MOBILE', res.data.body.logoMobile);
        }
        if (res.data.body.logoTablet) {
          context.commit('LOGO_TABLET', res.data.body.logoTablet);
        }
        if (res.data.body.menu) {
          // console.log('Menu: ', JSON.parse(res.data.body.menu));
          context.commit('MENU', JSON.parse(res.data.body.menu));
        }
        if (res.data.body.domains) {
          context.commit('DOMAINS', res.data.body.domains);
        }
        if(res.data.body.user_data.config.ROULETTE && res.data.body.user_data.config.ROULETTE.active == true && res.data.isLogged) {
          let totalKeytsSum = Object.values(context.getters.get_keyts_sum).reduce((acc, curr) => acc + curr, 0);

          if(!totalKeytsSum) {
            axios.post('RouletteAuthoraize', {no_loader: true, member: true}).then(res => {
              if(res.data.body.result == '0') {
                context.commit('MODAL', {
                  action: true,
                  content: {
                    width: 608,
                    title: 'Test',
                    curr_code: context.state.config.ROULETTE.curr_code,
                  },
                  type: 'TestMoney',
                });
              }
            });
          }          
        }
        // Инициализация WebSocket для уведомлений
        
        // if(res.data.body.user_data?.user_info_advanced?.socket_token) {
        //   context.dispatch('informator/init');
        // }
      })
    },
  },
  getters: {
    get_paypass_success_callback(state) {
      return state.paypass_success_callback;
    },
    get_isLogged (state) {
      return state.isLogged;
    },
    get_keyts (state) { 
      if (!state.userData.keyts) {
        return [];
      } else {
        let arr = [];
        state.userData.keyts.forEach(e => {
          arr.push(e);
        });
        return arr;
      }
    },
    get_user_name (state) {
      let str = '';
      if (state.userData.user_info.full_name) {
        str = state.userData.user_info.full_name.value;
      } else if (state.userData.user_info.surname) {
        str = state.userData.user_info.surname.value
        if (state.userData.user_info.firstname.value) {
          str = str + ' ' + state.userData.user_info.firstname.value.charAt(0);
        }
        if (state.userData.user_info.patronymic.value) {
          str = str + '. ' + state.userData.user_info.patronymic.value.charAt(0) + '.';
        }
      }
      return str;
    },
    get_currs_keyts_sum(state) {
      if (!state.userData.keyts) {
        return [];
      }
      let currs = [];
      let curr_list = {};
      let keyts =  structuredClone(state.userData.keyts);
      keyts.forEach(e => {
        currs.push(e.curr);
      });
      currs = Array.from(new Set(currs));
      currs.forEach(c => {
        keyts.forEach(k => {
          if (k.curr == c) {
            if (!curr_list[c]) {
              curr_list[c] = {
                'fiat':  k.fiat,
                'balance':  0,
                'value':  k.curr_name,
                'icon': k.curr_logo,
                'code':  k.curr,
                'curr_code':  k.curr_code,
                'keyt': k.keyt,
                'rate': k.rate,
                'precision': k.precision
              }
            }
            curr_list[c]['balance'] += Number(k.balance);
          }
        })
      })
      let arr = Object.values(curr_list);
      arr.sort((a, b) => {
        if (Number(a['balance']) < Number(b['balance'])) {
          return 1;
        }
        if (Number(a['balance']) > Number(b['balance'])) {
          return -1;
        }
        return 0;
      })
      return arr;
    },
    get_keyts_sum(state) {
      if (!state.userData.keyts) {
        return {};
      }
      let obj = {};
      let arr = [];
      state.userData.keyts.forEach(e => {
        arr.push(e.curr);
      });
      let tmp_arr = Array.from(new Set(arr));
      tmp_arr.forEach(e => {
        state.userData.keyts.forEach(a => {
          if (a.curr == e) {
            if (!obj[e]) {
              obj[e] = 0;
            }
            obj[e] += Number(a.balance);
          }
        });
      });
      let toSort = Object.entries(obj);
      toSort.sort((a, b) => {
        if (a[1] < b[1]) {
          return 1;
        }
        if (a[1] > b[1]) {
          return -1;
        }
        return 0;
      })
      obj = {};
      // let c = 3;
      // if (toSort.length < c) {
      //   c = toSort.length;
      // }
      // console.log(toSort )
      for (let i = 0; i < toSort.length; i++) {
        obj[toSort[i][0]] = toSort[i][1]
      }
      return obj;
    },
    get_sort_keyts(state) {
      let arr = [];
      if (!state.userData.keyts) {
        return [];
      }
      state.userData.keyts.forEach(e => {
        let image = '';
        if (e.curr_logo) {
          image = e.curr_logo;
        } else {
          try {
            image = require(`@/assets/currs/${e.curr.toUpperCase()}.svg`);
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e
            }
          }
        }
          
        e.image = image;
        arr.push(e);
      });
      arr.sort((a, b) => {
        if (Number(a['balance']) < Number(b['balance'])) {
          return 1;
        }
        if (Number(a['balance']) > Number(b['balance'])) {
          return -1;
        }
        return 0;
      })
      // console.log('Sort_arr', arr);
      return arr;
    },
    get_curr: (state) => (num) => {
      if (!state.userData.currs || !num) {
        return false;
      }
      let el = state.userData.currs.find((e) => {return e.code === num});
      return typeof el !== 'undefined' ? el : false;
    },
    get_keyts_keywords(state) {
      if (!state.userData.keyts) {
        return [];
      }
      let arr = [];
      // console.log(state.userData.keyts)
      state.userData.keyts.forEach(e => {
        let name = `${e['curr']} ${e['keyt']} ${e['name']} ( ${e['balance']} )`;

        let image = '';
        if (e.curr_logo) {
          image = e.curr_logo;
        } else {
          try {
            image = require(`@/assets/currs/${e.curr.toUpperCase()}.svg`);
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e
            }
          }
        }
          
        arr.push({
           'code': e['keyt'],
           'symbol': e['symbol'],
           'value': e.name, 
           'image': image,
           'curr': e['curr'],
           'precision': e['precision'],
           'curr_code': e['curr_code'],
           'balance': e['balance'],
           'alias': e['alias'],
           'explorer_link': e['explorer_link'],
          });
      });
      return arr;
    },
    get_warnings_list(state) {
      const successNotifications = state.notifications.list.filter(item => item.warningType === 'notification');
      const errorNotifications = state.notifications.list.filter(item => item.warningType === 'error');
      
      if(successNotifications.length) {
        return [...errorNotifications.slice(0, state.notifications.on_page - 1), ...successNotifications.slice(0, 1)];
      } else {
        return errorNotifications.slice(0, state.notifications.on_page);
      }
    },
    get_side_panel_visible(state) {
      return state.sidePanel.visible;
    },
    get_side_panel_title(state) {
      return state.sidePanel.title;
    },
    get_side_panel_content(state) {
      return state.sidePanel.content;
    }
  }
})
